import React, { FC } from 'react';
import { Link, Divider } from '@blueprint/ui';
import { Interpolate } from 'shared/i18n/Interpolate';

import registrationAndSignInTranslations from 'public/locales/en/registration-and-sign-in.json';
import { getTranslator } from 'shared/i18n/getTranslator';
import triggerTracking from '@blueprint/tracking/dist/Tracking';

import RegisterForm from './RegisterForm';
import {
    AuthContextText,
    TermsText,
    AuthModalHeading
} from './../../AuthModal.styles';
import { AuthModalProps } from './../../AuthModal.types';

const t = getTranslator(registrationAndSignInTranslations);
const alreadyRegisteredTn = t('alreadyRegistered');
const alreadyRegisteredLinkTextTn = t('alreadyRegisteredLinkText');
const termsAcceptanceTn = t('terms.acceptance');
const termsOfUseTn = t('terms.termsOfUse');
const termsPrivacyPolicyTn = t('terms.privacyPolicy');
const headingTn = t('heading');

const RegisterSection: FC<AuthModalProps> = ({
    heading,
    close,
    pathForSignIn = process.env.SIGNIN_PATH || '/signin/',
    actionAfterAuth,
    isSignInModalEnabled,
    resetActionAfterAuth
}) => (
    <>
        {!isSignInModalEnabled && (
            <>
                <AuthModalHeading size="6">
                    {heading || headingTn}
                </AuthModalHeading>
                <AuthContextText>
                    {alreadyRegisteredTn}
                    <Link
                        data-testid="signin-link"
                        onClick={() => {
                            triggerTracking({
                                event: 'GAEvent',
                                eventCategory: 'registration',
                                eventAction: 'click_to_signin',
                                eventLabel: actionAfterAuth?.eventLabel
                            });
                        }}
                        href={pathForSignIn}
                    >
                        {alreadyRegisteredLinkTextTn}
                    </Link>
                </AuthContextText>
                <Divider variant="horizontal" />
            </>
        )}

        <RegisterForm
            close={close}
            actionAfterAuth={actionAfterAuth}
            resetActionAfterAuth={resetActionAfterAuth}
            isSignInModalEnabled={isSignInModalEnabled}
        />

        <TermsText size="secondary">
            <Interpolate
                template={termsAcceptanceTn}
                values={{
                    linebreak: <br key="linebreak" />,
                    termsLink: (
                        <Link
                            key="terms"
                            data-testid="terms-link"
                            href="/terms/"
                            onClick={() => {
                                triggerTracking({
                                    event: 'GAEvent',
                                    eventCategory: 'registration',
                                    eventAction: 'click_to_terms',
                                    eventLabel: actionAfterAuth?.eventLabel
                                });
                            }}
                        >
                            {termsOfUseTn}
                        </Link>
                    ),
                    privacyLink: (
                        <Link
                            key="privacy"
                            data-testid="privacy-link"
                            href="/privacy/"
                            onClick={() => {
                                triggerTracking({
                                    event: 'GAEvent',
                                    eventCategory: 'registration',
                                    eventAction: 'click_to_privacy',
                                    eventLabel: actionAfterAuth?.eventLabel
                                });
                            }}
                        >
                            {termsPrivacyPolicyTn}
                        </Link>
                    )
                }}
            />
        </TermsText>
    </>
);

export default RegisterSection;
